import React from 'react';
import { UsersIcon } from 'lucide-react';
export function WelcomeMessage() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-3530">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-3531">
        <div className="flex items-start gap-4 p-6 rounded-xl mb-12 shadow-sm" style={{
        backgroundColor: '#ffffff',
        borderLeft: '4px solid #c8a84b',
        borderTop: '1px solid #ede9e0',
        borderRight: '1px solid #ede9e0',
        borderBottom: '1px solid #ede9e0'
      }} data-id="element-3532">
          <UsersIcon className="flex-shrink-0 mt-0.5" size={24} style={{
          color: '#1e3d2f'
        }} data-id="element-3533" />
          <p className="text-lg md:text-xl font-medium leading-relaxed" style={{
          color: '#1e3d2f',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-3534">
            We WELCOME kids and family to come and shoot, this is fun for all!
          </p>
        </div>
      </div>
    </div>;
}